import { userConstants } from './constantData';

const pdpCommonDimensions = [
  'v_content_name', /* 17 */
  'v_content_type', /* 18 */
  'v_content_id', /* 19 */
  'v_genre', /* 20 */
  'v_play_source', /* 21 */
  'v_content_player_type', /* 53 */
  'v_is_sports', /* 66 */
  'v_is_betting', /* 81 */
];

const PDP_PAGE_VIEW_HASH = 'p-019.037.000.000.000.000';

export const PDP_MOVIE_SERIE_LIVE_DATA = {
  pdp_movies_watch: {
    page_view: {
      hash: PDP_PAGE_VIEW_HASH,
      event: 'pages',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_collection_name', /* 36 */
        'v_component_type', /* 42 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    watch: {
      hash: 'e-019.037.001.000.000.009',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    resume: {
      hash: 'e-019.037.001.000.000.043',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    restart: {
      hash: 'e-019.037.001.000.000.106',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
  },
  pdp_movies_related_content: {
    filter_tab_pdp: {
      hash: 'e-019.037.001.000.000.221',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_filter_pdp', /* 70 */
      ],
    },
    watch_content: {
      hash: 'e-019.037.001.000.000.222',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_section_name', /* 31 */
        'v_list_position', /* 32 */
        'v_transmission_type', /* 34 */
        'v_filter_pdp', /* 70 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
  },
  pdp_serie_watch: {
    page_view: {
      hash: PDP_PAGE_VIEW_HASH,
      event: 'pages',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_collection_name', /* 36 */
        'v_component_type', /* 42 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    watch: {
      hash: 'e-019.037.001.000.000.009',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    resume: {
      hash: 'e-019.037.001.000.000.043',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    restart: {
      hash: 'e-019.037.001.000.000.106',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
  },
  pdp_serie_seasons_and_related_content: {
    filter_tab_pdp: {
      hash: 'e-019.037.001.000.000.221',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_filter_pdp', /* 70 */
      ],
    },
    select_season: {
      hash: 'e-019.037.001.000.000.105',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_text', /* 29 */
        'v_section_name', /* 31 */
        'v_list_position', /* 32 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_filter_pdp', /* 70 */
      ],
    },
    watch_content: {
      hash: 'e-019.037.001.000.000.222',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_list_position', /* 32 */
        'v_transmission_type', /* 34 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_filter_pdp', /* 70 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
  },
  pdp_movies_live: {
    page_view: {
      hash: PDP_PAGE_VIEW_HASH,
      event: 'pages',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_collection_name', /* 36 */
        'v_component_type', /* 42 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_time_to_start', /* 106 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
    watch_channel: {
      hash: 'e-019.037.001.000.000.110',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...pdpCommonDimensions,
        'v_channel_name', /* 23 */
        'v_serie_name', /* 24 */
        'v_season', /* 25 */
        'v_section_name', /* 31 */
        'v_transmission_type', /* 34 */
        'v_channel_id', /* 50 */
        'v_episode_number', /* 52 */
        'v_episode_name', /* 55 */
        'v_video_duration', /* 100 */
        'v_start_video_percentual', /* 104 */
        'v_time_to_start', /* 106 */
        'v_content_age_rating', /* 74 */
        'v_age_restricted_content', /* 75 */
      ],
    },
  },
};
